/*
中央处理转发
 */
import Vue from 'vue'

export const bus = new Vue()


// WEBPACK FOOTER //
// ./src/util/bus.js